/* Presentation only: no option values, prices, validation, storage or cart mutations. */
(() => {
  if (window.KaliaShadeSimple) return;
  const selector = 'kalia-product-studio[data-presentation="simple"]';
  const instances = new WeakMap();

  class KaliaShadeSimple {
    constructor(studio) {
      this.studio = studio;
      this.controller = new AbortController();
      studio.addEventListener('kalia:product-configuration-change', () => this.render(), { signal: this.controller.signal });
      this.render();
    }

    render() {
      const studio = this.studio;
      const finishing = studio.querySelector('[data-finishing-wrap]');
      const caption = studio.querySelector('[data-simple-finish-summary]');
      const selected = [];
      let missing = false;
      let newlyVisibleRequired = false;
      const requiredIds = new Set();
      studio.widgets?.forEach((widget, id) => {
        const field = studio.fieldMap?.get(id);
        if (!field) return;
        // Compact secondary choices keep the same radios, labels, fees and keyboard focus.
        const compact = widget.kind === 'operation' || (widget.kind === 'finish' && !/^valance$/i.test(String(field.title).trim()));
        widget.fieldset.classList.toggle('kss-compact', compact);
        if (widget.kind !== 'finish' || !studio.fieldVisible(id)) return;
        const choice = studio.selectedOption(field);
        if (field.required) {
          requiredIds.add(id);
          if (!this.visibleRequired?.has(id)) newlyVisibleRequired = true;
          if (!choice) missing = true;
        }
        if (choice) selected.push(studio.displayTitle(choice.label));
      });
      if (caption) {
        caption.textContent = missing ? 'Choose the remaining details below' : selected.length
          ? selected.slice(0, 3).join(' · ') + (selected.length > 3 ? ` · +${selected.length - 3} more` : '')
          : 'Review the available options';
        caption.title = selected.join(' · ');
      }
      // Show required details when they first become relevant, including existing defaults.
      // Missing choices stay open. A customer can collapse an already complete group.
      if (finishing && (missing || newlyVisibleRequired)) finishing.open = true;
      this.visibleRequired = requiredIds;
    }

    destroy() { this.controller.abort(); }
  }

  const attach = studio => {
    if (studio?.matches?.(selector) && studio.ready && !instances.has(studio)) instances.set(studio, new KaliaShadeSimple(studio));
  };
  document.addEventListener('kalia:product-studio-ready', event => attach(event.target));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(selector).forEach(attach));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(studio => {
      instances.get(studio)?.destroy();
      instances.delete(studio);
    });
  });
  const initialize = () => document.querySelectorAll(selector).forEach(attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.KaliaShadeSimple = KaliaShadeSimple;
})();
